import { Action, Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { Donor, donorApi } from '@/api'

@Module({
  name: 'DonorStore',
  namespaced: true,
  stateFactory: true
})
export default class DonorStore extends BaseStore {
  items: Donor[] = []

  get allItems(): Donor[] {
    return this.items
  }

  get findByCode(): (code: string) => Donor | undefined {
    return code => this.items.find(item => item.code === code)
  }

  get findById(): (id: number) => Donor | undefined {
    return id => this.items.find(item => item.id === id)
  }

  @Mutation
  public setItems(donors: Donor[]) {
    this.items = donors
  }

  @Action
  public async fetchAll() {
    const donors: Donor[] = await donorApi.getDonor()
    this.setItems(donors)
  }
}
